import { type AnyExtension } from '@tiptap/core'
import Document from '@tiptap/extension-document'
import Highlight from '@tiptap/extension-highlight'
import { Color, TextStyle } from '@tiptap/extension-text-style'
import StarterKit from '@tiptap/starter-kit'
import { AttendeeList } from './editor/extensions/nodes/attendee-list'
import { ChunkMark } from './editor/extensions/marks/chunk'
import { CommentAnchorMark } from './editor/extensions/marks/comment-anchor'
import { StrongMark } from './editor/extensions/marks/strong'
import { SuggestionMark } from './editor/extensions/marks/suggestion'
import { FilledPlaceholder } from './editor/extensions/nodes/filled-placeholder'
import { Placeholder } from './editor/extensions/nodes/placeholder'
import { ListNodes } from './editor/extensions/nodes/list'
import { MinuteTitle } from './editor/extensions/nodes/minute-title'
import { RestrictedSection } from './editor/extensions/nodes/restricted-section'

const MinuteDocument = Document.extend({
  content: 'minute_title{1} attendee_list{1} block+',
})

export const EDITOR_STRUCTURAL_EXTENSIONS: AnyExtension[] = [
  StarterKit.configure({
    // Disabled as we use the collaboration server instead.
    undoRedo: false,

    // Disable built-in extensions that we override.
    bold: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    document: false,
  }),
  MinuteDocument,
  MinuteTitle,
  AttendeeList,
  ...ListNodes,
  RestrictedSection,
  FilledPlaceholder,
  Placeholder,
  ChunkMark,
  StrongMark,
  SuggestionMark,
  CommentAnchorMark,
  Highlight.configure({ multicolor: false }),
  TextStyle,
  Color,
]
